import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=9d4c09ee&"
import script from "./EventPage.vue?vue&type=script&lang=js&"
export * from "./EventPage.vue?vue&type=script&lang=js&"
import style0 from "./EventPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
